import Home from './Home.vue'
import TeamPage from './TeamPage.vue'
import DataSecurity from './DataSecurity.vue'
import SiteNotice from './SiteNotice.vue'

const viewRoutes: any = [
    {
        path: '/',
        name: 'start',
        component: Home,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/team',
        name: 'team',
        component: TeamPage,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/datenschutz',
        name: 'datasecurity',
        component: DataSecurity,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/impressum',
        name: 'sitenotice',
        component: SiteNotice,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '*',
        redirect: '/'
    }
]

export default viewRoutes
